"use strict";
var __create = Object.create;
var __defProp = Object.defineProperty;
var __getOwnPropDesc = Object.getOwnPropertyDescriptor;
var __getOwnPropNames = Object.getOwnPropertyNames;
var __getProtoOf = Object.getPrototypeOf;
var __hasOwnProp = Object.prototype.hasOwnProperty;
var __export = (target, all) => {
  for (var name in all)
    __defProp(target, name, { get: all[name], enumerable: true });
};
var __copyProps = (to, from, except, desc) => {
  if (from && typeof from === "object" || typeof from === "function") {
    for (let key of __getOwnPropNames(from))
      if (!__hasOwnProp.call(to, key) && key !== except)
        __defProp(to, key, { get: () => from[key], enumerable: !(desc = __getOwnPropDesc(from, key)) || desc.enumerable });
  }
  return to;
};
var __toESM = (mod, isNodeMode, target) => (target = mod != null ? __create(__getProtoOf(mod)) : {}, __copyProps(
  // If the importer is in node compatibility mode or this is not an ESM
  // file that has been converted to a CommonJS file using a Babel-
  // compatible transform (i.e. "__esModule" has not been set), then set
  // "default" to the CommonJS "module.exports" for node compatibility.
  isNodeMode || !mod || !mod.__esModule ? __defProp(target, "default", { value: mod, enumerable: true }) : target,
  mod
));
var __toCommonJS = (mod) => __copyProps(__defProp({}, "__esModule", { value: true }), mod);

// src/queries/index.ts
var queries_exports = {};
__export(queries_exports, {
  forecastHealthCheck: () => forecastHealthCheck_default,
  getAvailableSlots: () => getAvailableSlots_default,
  getBookingByID: () => getBookingByID_default,
  getBookings: () => getBookings_default,
  getConsumer: () => getConsumer_default,
  getConsumerByID: () => getConsumerByID_default,
  getEntitlementsForProduct: () => getEntitlementsForProduct_default,
  getFlightDetails: () => getFlightDetails_default,
  getLocationDescription: () => getLocationDescription_default,
  getOutlet: () => getOutlet_default,
  getOutletLocationDetailsGroups: () => getOutletLocationDetailsGroups_default,
  getOutlets: () => getOutlets_default,
  getOutletsCount: () => getOutletsCount_default,
  getPartnerBrandByID: () => getPartnerBrandByID_default,
  getPartnerBrands: () => getPartnerBrands_default,
  getPartnerBrandsCount: () => getPartnerBrandsCount_default,
  getPartnerByID: () => getPartnerByID_default,
  getPaymentCards: () => getPaymentCards_default,
  getPaymentSession: () => getPaymentSession_default,
  getPaymentStatus: () => getPaymentStatus_default,
  getProductByCode: () => getProductByCode_default,
  getProductValuation: () => getProductValuation_default,
  getSearchAirports: () => searchAirports_default,
  getSearchExperiences: () => getSearchExperiences_default,
  getTokenExCvvConfig: () => getTokenExCvvConfig_default,
  getTranslation: () => getTranslation_default,
  getTranslations: () => getTranslations_default,
  getTranslationsCount: () => getTranslationsCount_default,
  getUserByID: () => getUserByID_default,
  getUsersForPartner: () => getUsersForPartner_default,
  getValidInvitationFromToken: () => getValidInvitationFromToken_default,
  me: () => me_default,
  verifyPaymentWebApp: () => verifyPaymentWebApp_default
});
module.exports = __toCommonJS(queries_exports);

// src/apollo.ts
var import_client = require("@apollo/client");
var import_link_error = require("@apollo/link-error");
var import_deepmerge = __toESM(require("deepmerge"));
var import_isEqual = __toESM(require("lodash/isEqual"));
var import_react = require("react");
var import_session = require("supertokens-auth-react/recipe/session");
var import_client2 = require("@apollo/client");
var graphqlUrl = process.env.NEXT_PUBLIC_PRODUCTION_API_URL;
var checkProtected = () => {
  if (typeof window !== "undefined") {
    const { pathname } = window.location;
    return !pathname.startsWith("/auth") && !pathname.startsWith("/signup");
  }
};
var redirectLogin = () => {
  if (typeof window !== "undefined") {
    window.location.href = `/auth/login/?redirecturl=${window.location.pathname + window.location.search}`;
  }
};
var withTokenRefresh = new import_client.ApolloLink((operation, forward) => {
  if (checkProtected()) {
    return (0, import_client.fromPromise)(
      (0, import_session.attemptRefreshingSession)().then((success) => {
        if (!success) {
          redirectLogin();
        }
        return (0, import_client.toPromise)(forward(operation));
      })
    );
  }
  return forward(operation);
});
var httpLink = new import_client.HttpLink({
  uri: graphqlUrl,
  credentials: "include"
});
var httpLinkProxy = new import_client.HttpLink({
  uri: "/api/graphql",
  credentials: "include"
});
var errorLink = (0, import_link_error.onError)(({ graphQLErrors, networkError }) => {
  if (graphQLErrors) {
    graphQLErrors.forEach(
      ({ message, locations, path }) => console.log(
        `[GraphQL error]: Message: ${message}, Location: ${locations}, Path: ${path}`
      )
    );
  }
  if (networkError) {
    console.log(
      `[Network error]: ${networkError}. Backend is unreachable. Is it running?`,
      `[Graphql URL]: ${graphqlUrl}`
    );
  }
});

// src/queries/forecastHealthCheck.ts
var forecast = import_client2.gql`
  query Forecast($loungeBusynessInput: LoungeBusynessInput) {
    forecast(loungeBusynessInput: $loungeBusynessInput) {
      level
    }
  }
`;
var forecastHealthCheck_default = forecast;

// src/queries/getAvailableSlots.ts
var getAvailableSlots = import_client2.gql`
  query GetAvailableSlots($data: AvailabilityInput!) {
    getAvailableSlots(data: $data) {
      slots {
        startDate
        endDate
        maxDuration
        slotConfigurationId
      }
      partnerMetadata
    }
  }
`;
var getAvailableSlots_default = getAvailableSlots;

// src/queries/getBookingByID.ts
var getBookingByID = import_client2.gql`
  query GetBookingById($getBookingById: ID!) {
    getBookingByID(id: $getBookingById) {
      actingAccount
      bookedFrom
      bookedTo
      lastArrival
      metadata
      reference
      createdAt
      price
      price_currency
      guestAdultCount
      guestChildrenCount
      guestInfantCount
      partnerMetadata
      status
      id
      consumer {
        emailAddress
        fullName
        id
      }
      experience {
        loungeName
        openingHours
        id
        images {
          altText
          contentType
          height
          id
          url
          width
        }
        location {
          airportName
          terminal
        }
        pricing {
          currency
          reservationOnlyFee
          reservationCost
        }
      }
      refundStatus
      usedEntitlementsCount
      entitlements {
        expiryDate
        expired
        id
        redeemed
        refunded
        isUnlimited
      }
    }
  }
`;
var getBookingByID_default = getBookingByID;

// src/queries/getBookings.ts
var getBookings = import_client2.gql`
  query GetBookings($status: BookingStatus, $experienceId: ID!) {
    getBookings(status: $status, experienceID: $experienceId) {
      bookedFrom
      bookedTo
      createdAt
      type
      metadata
      id
      reference
      guestAdultCount
      guestChildrenCount
      guestInfantCount
      status
      createdAt
      updatedAt
      consumer {
        emailAddress
        firstName
        fullName
        id
      }
      experience {
        id
        loungeName
      }
    }
  }
`;
var getBookings_default = getBookings;

// src/queries/getConsumer.ts
var getConsumer = import_client2.gql`
  query GetConsumer {
    getConsumer {
      id
      crmId
      fullName
      firstName
      lastName
      emailAddress
      createdAt
      updatedAt
    }
  }
`;
var getConsumer_default = getConsumer;

// src/queries/getConsumerByID.ts
var getConsumerByID = import_client2.gql`
  query GetConsumerByID($getConsumerById: ID!) {
    getConsumerByID(id: $getConsumerById) {
      linkedAccounts {
        membershipID
        membershipType
        provider
        updatedAt
        id
        createdAt
        analytics
        externalID
        memberships {
          id
          membershipNumber
        }
        sourceCode
      }
      memberships {
        id
        membershipNumber
      }
      firstName
      lastName
      dateOfBirth
      createdAt
      emailAddress
      id
      updatedAt
      locale
    }
  }
`;
var getConsumerByID_default = getConsumerByID;

// src/queries/getEntitlementsForProduct.ts
var getEntitlementsForProduct = import_client2.gql`
  query GetEntitlementsForProduct(
    $productId: ID!
    $bookingEnd: Date
    $bookingStart: Date
    $consumerId: ID
    $membershipID: ID
    $retry: Boolean
  ) {
    getEntitlementsForProduct(
      productId: $productId
      bookingEnd: $bookingEnd
      bookingStart: $bookingStart
      membershipID: $membershipID
      consumerId: $consumerId
      retry: $retry
    ) {
      expiryDate
      expired
      id
      redeemed
      isUnlimited
      perVisitLimit
    }
  }
`;
var getEntitlementsForProduct_default = getEntitlementsForProduct;

// src/queries/getFlightDetails.ts
var getFlightDetails = import_client2.gql`
  query GetFlightDetails($flightDetails: FlightDetailsInput!) {
    getFlightDetails(flightDetails: $flightDetails) {
      arrival {
        airport
        terminal
        dateTime {
          local
          utc
        }
      }
      departure {
        airport
        terminal
        dateTime {
          local
          utc
        }
      }
    }
  }
`;
var getFlightDetails_default = getFlightDetails;

// src/queries/getLocationDescription.ts
var getLocationDescription = import_client2.gql`
  query GetLocationDescription(
    $locationDetails: OutletLocationDetailsInput!
    $isLandside: Boolean!
  ) {
    getLocationDescription(
      locationDetails: $locationDetails
      isLandside: $isLandside
    )
  }
`;
var getLocationDescription_default = getLocationDescription;

// src/queries/getOutlet.ts
var getOutlet = import_client2.gql`
  query GetOutlet(
    $getOutletId: ID!
    $outletIdType: outletIDType!
    $additionalFilters: ProductFilters
  ) {
    getOutlet(
      outletIDType: $outletIdType
      additionalFilters: $additionalFilters
      id: $getOutletId
    ) {
      id
      name
      maxGuests
      maxStayHours
      activationDate
      permanentClosureDate
      managedChoicesOrdering {
        locationDetails
      }
      additionalDescription {
        accessTimes {
          id
          text
          status
        }
        conditions {
          id
          text
          status
        }
        importantInformation {
          id
          text
          status
        }
        location {
          id
          text
          status
        }
      }
      draft {
        id
        name
        activationDate
        permanentClosureDate
        managedChoicesOrdering {
          locationDetails
        }
        additionalDescription {
          accessTimes {
            id
            text
            status
          }
          conditions {
            id
            text
            status
          }
          importantInformation {
            id
            text
            status
          }
          location {
            id
            text
            status
          }
        }
        accessTimes {
          accessHours {
            monday {
              endTime
              startTime
            }
            tuesday {
              endTime
              startTime
            }
            wednesday {
              endTime
              startTime
            }
            thursday {
              endTime
              startTime
            }
            friday {
              endTime
              startTime
            }
            saturday {
              endTime
              startTime
            }
            sunday {
              endTime
              startTime
            }
          }
          description
          exceptions {
            accessHours {
              startTime
              endTime
            }
            date
            startDate
            endDate
            exceptionType
            isOpen
            name
            priority
            isRecurring
          }
          peakHours {
            startTime
            endTime
          }
        }
        conditions {
          allowedSmokingPolicy
          childrenAdmittedFreeNumber {
            maximum
            per
          }
          childrenAdmittedFreeAge {
            from
            to
          }
          childrenAllowed
          childrenMustBeAccompaniedUnderAge
          description
          dressCodeOptions {
            noAboveKneeSkirtsOrDresses
            noBaseballCaps
            noSandals
            noShorts
            noSleevelessTops
            noSportswear
            noTShirts
            smartCasual
          }
          hasDressCode
          minimumChildAge
          smokingAllowed
        }
        display {
          conditions
          locationDetails
          importantInformation
          additionalAccessTimes
          additionalConditions
          additionalLocationDetails
        }
        facilities {
          id
          name
          isAvailable
          details {
            ageLimit
            complimentaryDrinks
            complimentaryAlcoholicDrinks
            extraPaymentRequired
            preBookingRequired
            runwayViewFromAllSeats
            digitalFormatMagazines
            paperFormatMagazines
          }
        }
        location {
          pointOfInterestID
          city
          code
          country
          description
          isoCountryCode
          landside
          latitude
          longitude
          name
          terminal
          timezone
          type
        }
        locationDetails {
          outletZone
          passportControl
          gateNumber
          gateNumberTwo
          gateLocationDirection
          concourse {
            letterOrNumber
            name
            directions {
              takeStairs
              takeLift
              takeEscalator
              takeBus
              takeShuttle
              takeTrain
            }
          }
          floor {
            letterOrNumber
            name
            directions {
              takeStairs
              takeLift
              takeEscalator
              takeBus
              takeShuttle
              takeTrain
            }
          }
          level {
            letterOrNumber
            name
            directions {
              takeStairs
              takeLift
              takeEscalator
              takeBus
              takeShuttle
              takeTrain
            }
          }
          pier {
            letterOrNumber
            name
          }
          satellite {
            letterOrNumber
            name
          }
          zone {
            letterOrNumber
            name
          }
          module {
            letterOrNumber
            name
          }
          dutyFreeDirection
          foodCourtDirection
          foodCourtName
          hasSignName
          signName
        }
        media {
          mainImage {
            asset {
              id
              contentType
              description
              fileName
              height
              title
              url
              width
            }
            metadata {
              lastEdited
              editor {
                firstName
                lastName
              }
            }
          }
          images {
            asset {
              id
              contentType
              description
              fileName
              height
              title
              url
              width
            }
            metadata {
              lastEdited
              editor {
                firstName
                lastName
              }
            }
          }
        }
        meta {
          editor {
            firstName
            lastName
            organisation
          }
          lastEdited
          edited
        }
        products {
          accessType
          category
          costs {
            cost
            costCurrency
            defaultTaxPercentage
            programme
            projectedCost
            reservationCost
            type
          }
          id
          name
          ppStripeID
          salePrices {
            programme
            salePrice
            salePriceCurrency
            stripePriceID
          }
          salesforceID
          stage
          status
          tier
        }
        sectionsMeta {
          accessTimes {
            editor {
              firstName
              lastName
              organisation
            }
            lastEdited
            lastEditedByType
            edited
            isIncomplete
          }
          importantInfo {
            editor {
              firstName
              lastName
              organisation
            }
            lastEdited
            lastEditedByType
            edited
            isIncomplete
          }
          conditions {
            editor {
              firstName
              lastName
              organisation
            }
            lastEdited
            lastEditedByType
            edited
            isIncomplete
          }
          facilities {
            editor {
              firstName
              lastName
              organisation
            }
            lastEdited
            lastEditedByType
            edited
            isIncomplete
          }
          location {
            editor {
              firstName
              lastName
              organisation
            }
            lastEdited
            lastEditedByType
            edited
            isIncomplete
          }
          media {
            editor {
              firstName
              lastName
              organisation
            }
            lastEdited
            lastEditedByType
            edited
            isIncomplete
          }
        }
        editedSections
        versionStatus
        workflow {
          status
          submittedAt
          rejectionReason
        }
      }
      salesforceID
      category
      code
      category
      passengerTypes
      partnerBrand {
        id
        name
        partnerIntegrationData {
          partnerIntegrationID
        }
      }
      facilities {
        id
        name
        isAvailable
        details {
          ageLimit
          complimentaryDrinks
          complimentaryAlcoholicDrinks
          extraPaymentRequired
          preBookingRequired
          runwayViewFromAllSeats
          digitalFormatMagazines
          paperFormatMagazines
        }
      }
      legacyFacilities {
        id
        name
        isAvailable
      }
      location {
        timezone
        city
        code
        country
        description
        isoCountryCode
        landside
        latitude
        longitude
        name
        terminal
        type
        meta {
          editor {
            lastName
            firstName
            organisation
          }
          lastEdited
        }
      }
      locationDetails {
        outletZone
        passportControl
        gateNumber
        gateNumberTwo
        gateLocationDirection
        concourse {
          letterOrNumber
          name
          directions {
            takeStairs
            takeLift
            takeEscalator
            takeBus
            takeShuttle
            takeTrain
          }
        }
        floor {
          letterOrNumber
          name
          directions {
            takeStairs
            takeLift
            takeEscalator
            takeBus
            takeShuttle
            takeTrain
          }
        }
        level {
          letterOrNumber
          name
          directions {
            takeStairs
            takeLift
            takeEscalator
            takeBus
            takeShuttle
            takeTrain
          }
        }
        pier {
          letterOrNumber
          name
        }
        satellite {
          letterOrNumber
          name
        }
        zone {
          letterOrNumber
          name
        }
        module {
          letterOrNumber
          name
        }
        dutyFreeDirection
        foodCourtDirection
        foodCourtName
        hasSignName
        signName
      }
      meta {
        editor {
          lastName
          firstName
          organisation
        }
        lastEdited
        edited
      }
      workflowStage
      ancillaryProducts {
        tier
        costs {
          cost
          costCurrency
          programme
          defaultTaxPercentage
          projectedCost
          reservationCost
          type
        }
        salePrices {
          programme
          salePrice
          salePriceCurrency
          stripePriceID
        }
        name
        id
        salesforceID
        status
      }
      products {
        id
        name
        tier
        costs {
          cost
          costCurrency
          programme
          defaultTaxPercentage
          projectedCost
          reservationCost
          type
        }
        partnerIntegrationData {
          partnerProductID
        }
        salePrices {
          programme
          salePrice
          salePriceCurrency
          stripePriceID
        }
        status
        category
        accessType
        salesforceID
        stage
      }
      editedSections
      tier
      conditions {
        allowedSmokingPolicy
        childrenAdmittedFreeNumber {
          maximum
          per
        }
        childrenAdmittedFreeAge {
          from
          to
        }
        childrenAllowed
        childrenMustBeAccompaniedUnderAge
        description
        dressCodeOptions {
          noAboveKneeSkirtsOrDresses
          noBaseballCaps
          noSandals
          noShorts
          noSleevelessTops
          noSportswear
          noTShirts
          smartCasual
        }
        hasDressCode
        minimumChildAge
        smokingAllowed
      }
      display {
        conditions
        locationDetails
        importantInformation
        additionalAccessTimes
        additionalConditions
        additionalLocationDetails
      }
      accessTimes {
        accessHours {
          monday {
            startTime
            endTime
          }
          tuesday {
            startTime
            endTime
          }
          wednesday {
            startTime
            endTime
          }
          thursday {
            startTime
            endTime
          }
          friday {
            startTime
            endTime
          }
          saturday {
            startTime
            endTime
          }
          sunday {
            startTime
            endTime
          }
        }
        peakHours {
          startTime
          endTime
        }
        description
        exceptions {
          accessHours {
            startTime
            endTime
          }
          startDate
          endDate
          date
          exceptionType
          isOpen
          name
          priority
          isRecurring
        }
      }
      media {
        mainImage {
          asset {
            id
            contentType
            description
            fileName
            height
            title
            url
            width
          }
          metadata {
            lastEdited
            editor {
              firstName
              lastName
            }
          }
        }
        images {
          asset {
            id
            contentType
            description
            fileName
            height
            title
            url
            width
          }
          metadata {
            lastEdited
            editor {
              firstName
              lastName
            }
          }
        }
      }
      status
      salesforceID
      reservationEmail
      reservationEmails
      partnerBrand {
        name
      }
      sectionsMeta {
        location {
          editor {
            firstName
            lastName
            organisation
          }
          lastEdited
          lastEditedByType
          edited
          isIncomplete
        }
        media {
          editor {
            firstName
            lastName
            organisation
          }
          lastEdited
          lastEditedByType
          edited
          isIncomplete
        }
        accessTimes {
          editor {
            firstName
            lastName
            organisation
          }
          lastEdited
          lastEditedByType
          edited
          isIncomplete
        }
        conditions {
          editor {
            firstName
            lastName
            organisation
          }
          lastEdited
          lastEditedByType
          edited
          isIncomplete
        }
        importantInfo {
          editor {
            firstName
            lastName
            organisation
          }
          lastEdited
          lastEditedByType
          edited
          isIncomplete
        }
        facilities {
          editor {
            firstName
            lastName
            organisation
          }
          lastEdited
          lastEditedByType
          edited
          isIncomplete
        }
      }
      workflowStage
      lockedVersion
    }
  }
`;
var getOutlet_default = getOutlet;

// src/queries/getOutlets.ts
var getOutlets = import_client2.gql`
  query GetOutlets(
    $page: Int
    $pageSize: Int
    $filters: OutletAndProductFilters
  ) {
    getOutlets(page: $page, pageSize: $pageSize, filters: $filters) {
      items {
        draft {
          workflow {
            status
            rejectionReason
          }
          media {
            mainImage {
              asset {
                url
                description
                title
              }
            }
            images {
              asset {
                url
              }
            }
          }
          sectionsMeta {
            accessTimes {
              isIncomplete
            }
            conditions {
              isIncomplete
            }
            facilities {
              isIncomplete
            }
            importantInfo {
              isIncomplete
            }
            location {
              isIncomplete
            }
            media {
              isIncomplete
            }
          }
        }
        id
        name
        code
        status
        location {
          name
          city
          code
          terminal
          type
        }
        partnerBrand {
          id
          name
        }
        category
        media {
          mainImage {
            asset {
              url
              description
              title
            }
          }
          images {
            asset {
              contentType
              url
              description
              title
            }
          }
        }
        workflowStage
        sectionsMeta {
          accessTimes {
            isIncomplete
          }
          conditions {
            isIncomplete
          }
          facilities {
            isIncomplete
          }
          importantInfo {
            isIncomplete
          }
          location {
            isIncomplete
          }
          media {
            isIncomplete
          }
        }
      }
      pageInfo {
        currentPage
        hasNextPage
        hasPreviousPage
        totalPages
      }
      totalItemCount
    }
  }
`;
var getOutlets_default = getOutlets;

// src/queries/getOutletsCount.ts
var getOutletsCount = import_client2.gql`
  query GetOutletsCount($filters: OutletAndProductFilters) {
    getOutlets(filters: $filters) {
      totalItemCount
    }
  }
`;
var getOutletsCount_default = getOutletsCount;

// src/queries/getPartnerBrands.ts
var getPartnerBrands = import_client2.gql`
  query GetPartnerBrands(
    $page: Int
    $pageSize: Int
    $filters: PartnerBrandFilters
  ) {
    getPartnerBrands(page: $page, pageSize: $pageSize, filters: $filters) {
      items {
        id
        name
        outlets {
          id
        }
        status
      }
      pageInfo {
        currentPage
        hasNextPage
        hasPreviousPage
        totalPages
      }
      totalItemCount
    }
  }
`;
var getPartnerBrands_default = getPartnerBrands;

// src/queries/getPartnerBrandsCount.ts
var getPartnerBrandsCount = import_client2.gql`
  query GetPartnerBrandsCount($filters: PartnerBrandFilters) {
    getPartnerBrands(filters: $filters) {
      totalItemCount
    }
  }
`;
var getPartnerBrandsCount_default = getPartnerBrandsCount;

// src/queries/getPartnerByID.ts
var getPartnerByID = import_client2.gql`
  query GetPartnerByID($getPartnerById: ID!) {
    getPartnerByID(id: $getPartnerById) {
      id
      lastName
      updatedAt
      firstName
      fullName
      createdAt
      emailAddress
    }
  }
`;
var getPartnerByID_default = getPartnerByID;

// src/queries/getPaymentCards.ts
var import_client3 = require("@apollo/client");
var getPaymentCards = import_client3.gql`
  query GetPaymentCards($paymentProvider: PaymentProvider, $membershipId: ID) {
    getPaymentCards(
      paymentProvider: $paymentProvider
      membershipId: $membershipId
    ) {
      id
      brand
      name
      expiryMonth
      expiryYear
      last4Digits
      isDefault
      isTokenEx
      saved
      pspCardReferenceId
      paymentServiceProvider
      address {
        company
        line1
        line2
        town
        county
        postcode
        country
      }
    }
  }
`;
var getPaymentCards_default = getPaymentCards;

// src/queries/getPaymentSession.ts
var import_client4 = require("@apollo/client");
var getPaymentSession = import_client4.gql`
  query GetPaymentSession(
    $paymentSessionContext: PaymentSessionContextInput!
    $membershipId: ID
  ) {
    getPaymentSession(
      paymentSessionContext: $paymentSessionContext
      membershipId: $membershipId
    ) {
      entityId
      paymentSessionId
      paymentServiceProvider
      dealId
      tokenExCvvConfig {
        tokenExId
        origin
        timestamp
        authenticationKey
        token
        cardType
      }
    }
  }
`;
var getPaymentSession_default = getPaymentSession;

// src/queries/getPaymentStatus.ts
var import_client5 = require("@apollo/client");
var getPaymentStatus = import_client5.gql`
  query GetPaymentStatus($paymentId: ID!) {
    getPaymentStatus(paymentId: $paymentId) {
      status
      id
      type
      value {
        amount
        currency
        transactionType
      }
    }
  }
`;
var getPaymentStatus_default = getPaymentStatus;

// src/queries/getTokenExCvvConfig.ts
var import_client6 = require("@apollo/client");
var getTokenExCvvConfig = import_client6.gql`
  query GetTokenExCvvConfig(
    $cardId: ID!
    $paymentId: ID!
    $accessCode: String!
  ) {
    getTokenExCvvConfig(
      cardId: $cardId
      paymentId: $paymentId
      accessCode: $accessCode
    ) {
      tokenExId
      origin
      timestamp
      authenticationKey
      token
      cardType
    }
  }
`;
var getTokenExCvvConfig_default = getTokenExCvvConfig;

// src/queries/getProductByCode.ts
var getProductByCode = import_client2.gql`
  query GetProductByCode($code: String!, $filters: ProductFilters) {
    getProductByCode(code: $code, filters: $filters) {
      id
      costs {
        cost
        costCurrency
        defaultTaxPercentage
        programme
        projectedCost
        reservationCost
        type
      }
      salePrices {
        programme
        salePrice
        salePriceCurrency
        stripePriceID
      }
      salesforceID
      status
      tier
      accessType
      category
      code
      location {
        city
        code
        country
        landside
        isoCountryCode
        name
        terminal
        type
      }
      partnerBrand {
        id
      }
      stage
      outlet {
        id
      }
      partnerIntegrationData {
        accessPeriod
        agreedPrebookHoldTime
        amendPeriodAllowed
        bookingFlowType
        bookingMaxPeriodAllowed
        bookingMinPeriodAllowed
        cancellationPeriodAllowed
        maxGuests {
          adult {
            isChargeable
            isPartySizeImpacted
            value
          }
          children {
            isChargeable
            isPartySizeImpacted
            value
          }
          infant {
            isChargeable
            isPartySizeImpacted
            value
          }
          partySize
          senior {
            isChargeable
            isPartySizeImpacted
            value
          }
        }
        partnerIntegrationID
        partnerProductID
        pdfGuideUrl
        stripeProductID
        timeSlotPeriod
      }
    }
  }
`;
var getProductByCode_default = getProductByCode;

// src/queries/getProductValuation.ts
var getProductValuation = import_client2.gql`
  query ProductValuation($valuationInput: ProductValuationInput!) {
    getProductValuation(valuationInput: $valuationInput) {
      consumerID
      entitlements {
        expiryDate
        expired
        id
        redeemed
        isUnlimited
      }
      dealEntitlements {
        perVisitLimit
      }
      membershipID
      priceDetails {
        currency
        finalPrice
        taxAmount
        isTaxInclusive
        priceZone
        guestPrices
        memberPrice
        coveredByEntitlement
        chargeOwnerTaxDetails {
          chargeOwner
          collinsonBillingLegalEntity
          isTaxExempt
          taxDecisionCode
          taxesApplied {
            taxCode
            taxRate
            taxType
          }
        }
        priceBreakdown {
          consumerPrice
          consumerPriceDetails {
            currency
            gross
            isTaxInclusive
            net
            priceZone
            taxAmount
          }
          clientPriceDetails {
            currency
            gross
            isTaxInclusive
            net
            priceZone
            taxAmount
          }
          visitorData {
            isGuest
            visitorType
          }
        }
      }
    }
  }
`;
var getProductValuation_default = getProductValuation;

// src/queries/getSearchExperiences.ts
var import_client7 = require("@apollo/client");
var getSearchExperiences = import_client7.gql`
  query SearchExperiences($query: String, $searchFilter: SearchFilterInput) {
    searchExperiences(query: $query, searchFilter: $searchFilter) {
      id
      loungeName
      loungeCode
      location {
        airportName
        airportCode
        city
        country
        terminal
        timezone
      }
      partnerIdProd
      partnerIdTest
      partnerIntegrationId
      pricing {
        pricingType
        currency
        reservationCost
        lifestyleXReservationCharge
        walkInCostCurrentPPRate
        lifestyleXWalkInCharge
        lifestyleXReservationCharge
        vat
        reservationOnlyFeeCost
        reservationOnlyFee
      }
      facilities
      openingHours
      conditions
      directions
      images {
        altText
        url
        height
        width
        id
      }
    }
  }
`;
var getSearchExperiences_default = getSearchExperiences;

// src/queries/verifyPaymentWebApp.ts
var import_client8 = require("@apollo/client");
var verifyPaymentWebApp = import_client8.gql`
  query VerifyPaymentWebApp($url: String!) {
    verifyPaymentWebApp(url: $url) {
      accessCode
      ui {
        locale
        mode
        paymentMethods
        theme
        successUrl
        errorUrl
        allowedBins
        declinedBins
      }
      source
      error {
        code
        isRetryable
        message
      }
      consumer {
        phoneNumber
        email
        givenName
        familyName
      }
      paymentServiceProvider
      paymentStatusResult
      paymentType
      preAuthCardId
      membershipId
      dealId
      amount {
        amount
        currency
        transactionType
      }
      tokenExIframeConfig {
        tokenExId
        origin
        timestamp
        authenticationKey
        tokenScheme
      }
      tokenExCvvConfig {
        tokenExId
        origin
        timestamp
        authenticationKey
        token
        cardType
      }
    }
  }
`;
var verifyPaymentWebApp_default = verifyPaymentWebApp;

// src/queries/searchAirports.ts
var getSearchAirports = import_client2.gql`
  query SearchAirports($airportQuery: AirportSearchInput) {
    searchAirports(airportQuery: $airportQuery) {
      name
      iata
      city
      country
      lat
      lng
      geoloc {
        lat
        lng
      }
      outletCategories
      type
      isServiceable
      terminals
    }
  }
`;
var searchAirports_default = getSearchAirports;

// src/queries/getOutletLocationDetailsGroups.ts
var getOutletLocationDetailsGroups = import_client2.gql`
  query GetOutletLocationDetailsGroups(
    $locationDetails: OutletLocationDetailsInput!
    $isLandside: Boolean
    $sortOrder: [OutletLocationDetailsSection]
  ) {
    getOutletLocationDetailsGroups(
      locationDetails: $locationDetails
      isLandside: $isLandside
      sortOrder: $sortOrder
    ) {
      section
      locationDetails
    }
  }
`;
var getOutletLocationDetailsGroups_default = getOutletLocationDetailsGroups;

// src/queries/getTranslation.ts
var getTranslation = import_client2.gql`
  query GetTranslation($id: ID!, $translationIdType: translationIdType!) {
    getTranslation(id: $id, translationIdType: $translationIdType) {
      id
      translationStatus
      requestedBy
      requestedAt
      receivedAt
      translationId
      originOutletId
      originSection
      outletSummary {
        code
        name
        location {
          city
          country
          code

          terminal
        }
      }
      translations {
        ar
        de
        en_GB
        es
        fr_CA
        fr_FR
        id
        it
        ja
        ko
        ms
        nl
        pl
        pt
        ru
        th
        tr
        uk
        vi
        zh_CN
        zh_Hant_HK
        zh_Hant_TW
      }
    }
  }
`;
var getTranslation_default = getTranslation;

// src/queries/getTranslationsCount.ts
var getTranslationsCount = import_client2.gql`
  query GetTranslationsCount($status: [TranslationStatus!]) {
    getTranslations(status: $status) {
      totalCount
    }
  }
`;
var getTranslationsCount_default = getTranslationsCount;

// src/queries/getTranslations.ts
var getTranslations = import_client2.gql`
  query GetTranslations(
    $status: [TranslationStatus!]
    $page: Int
    $pageSize: Int
  ) {
    getTranslations(status: $status, page: $page, pageSize: $pageSize) {
      nodes {
        id
        translationStatus
        requestedBy
        requestedAt
        receivedAt
        translationId
        originOutletId
        originSection
        outletSummary {
          code
          name
          location {
            city
            country
            code

            terminal
          }
        }
        translations {
          ar
          de
          en_GB
          es
          fr
          id
          it
          ja
          ko
          ms
          nl
          pl
          pt
          ru
          th
          tr
          uk
          vi
          zh_CN
          zh_Hant_HK
        }
      }
      totalCount
    }
  }
`;
var getTranslations_default = getTranslations;

// src/queries/getValidInvitationFromToken.ts
var import_client9 = require("@apollo/client");
var getValidInvitationFromToken = import_client9.gql`
  query GetValidInvitationFromToken($inviteToken: String!) {
    getValidInvitationFromToken(inviteToken: $inviteToken) {
      isValid
      invitation {
        id
        firstName
        lastName
        inviteeEmail
        outletIDs
        partnerId
        expiresAt
        createdAt
        updatedAt
      }
    }
  }
`;
var getValidInvitationFromToken_default = getValidInvitationFromToken;

// src/queries/me.ts
var me = import_client2.gql`
  query GetMe {
    me {
      user {
        id
        email
        firstName
        lastName
        userType
        status
        roles {
          id
          name
          description
          type
          isSystem
          permissions {
            id
            name
            description
            resource
            action
          }
        }
        customPermissions {
          id
          name
          description
          resource
          action
        }
        outletScope
        partnerBrandIds
        lastLoginAt
        createdAt
        updatedAt
      }
      resolvedPermissions
    }
  }
`;
var me_default = me;

// src/queries/getUsersForPartner.ts
var getUsersForPartner = import_client2.gql`
  query GetUsersForPartner($page: Int, $pageSize: Int) {
    getUsersForPartner(page: $page, pageSize: $pageSize) {
      nodes {
        id
        firstName
        lastName
        email
        status
        lastLoginAt
        partnerBrandIds
        customPermissions {
          action
          description
          id
          name
          resource
        }
        roles {
          id
          name
          description
          permissions {
            id
            name
            description
            resource
            action
          }
        }
      }
      totalCount
    }
  }
`;
var getUsersForPartner_default = getUsersForPartner;

// src/queries/getPartnerBrandByID.ts
var getPartnerBrandByID = import_client2.gql`
  query GetPartnerBrandByID($id: ID!, $filters: OutletAndProductFilters) {
    getPartnerBrandByID(id: $id, filters: $filters) {
      id
      name
      outlets {
        id
        name
        code
        status
        location {
          name
          terminal
          type
          city
          code
        }
        category
        media {
          mainImage {
            asset {
              url
              description
              title
            }
            metadata {
              lastEdited
              editor {
                firstName
                lastName
              }
            }
          }
          images {
            asset {
              url
              description
              title
            }
            metadata {
              lastEdited
              editor {
                firstName
                lastName
              }
            }
          }
        }
        workflowStage
      }
    }
  }
`;
var getPartnerBrandByID_default = getPartnerBrandByID;

// src/queries/getUserByID.ts
var getUserByID = import_client2.gql`
  query GetUserByID($id: ID!) {
    getUserByID(id: $id) {
      id
      firstName
      lastName
      partnerBrandIds
      roles {
        type
      }
    }
  }
`;
var getUserByID_default = getUserByID;
// Annotate the CommonJS export names for ESM import in node:
0 && (module.exports = {
  forecastHealthCheck,
  getAvailableSlots,
  getBookingByID,
  getBookings,
  getConsumer,
  getConsumerByID,
  getEntitlementsForProduct,
  getFlightDetails,
  getLocationDescription,
  getOutlet,
  getOutletLocationDetailsGroups,
  getOutlets,
  getOutletsCount,
  getPartnerBrandByID,
  getPartnerBrands,
  getPartnerBrandsCount,
  getPartnerByID,
  getPaymentCards,
  getPaymentSession,
  getPaymentStatus,
  getProductByCode,
  getProductValuation,
  getSearchAirports,
  getSearchExperiences,
  getTokenExCvvConfig,
  getTranslation,
  getTranslations,
  getTranslationsCount,
  getUserByID,
  getUsersForPartner,
  getValidInvitationFromToken,
  me,
  verifyPaymentWebApp
});
